import { GeoNames } from "../../components/SearchInput";

import SimpleBooking from "../../components/Logistics/SimpleBooking";
// import CustomBooking from "../components/Logistics/CustomBooking";

export type FormValuesType = {
  from: Omit<GeoNames, "adminCode1" | "geonameId">;
  to: Omit<GeoNames, "adminCode1" | "geonameId">;
  loading_date: string;
  // shipppingType: {
  container_size: string;
  freight_type: string;
  transportation_by: string;
  // };
};

const CargoDetails = () => {
  return (
    <section className="relative pl-10 pr-2">
      <SimpleBooking />
    </section>
  );
};

export default CargoDetails;
